import script from "./CapabilitiesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CapabilitiesModal.vue?vue&type=script&setup=true&lang=js"

import "./CapabilitiesModal.vue?vue&type=style&index=0&id=5b292871&scoped=true&lang=css"
import "./CapabilitiesModal.vue?vue&type=style&index=1&id=5b292871&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b292871"]])

export default __exports__